import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { CognitoUser, AuthenticationDetails } from "amazon-cognito-identity-js";
import { Form, Button } from "react-bootstrap";
import IconImg from "../../image/Vote_Center_Logo.png";

import UserPool from "./UserPool";
import { signIn } from "../../actions";
import history from "../../history";

class Login extends Component {
  constructor(props) {
    super(props);
    this.usernameInput = React.createRef();
  }

  state = {
    username: "",
    password: "",
    name: "",
    changePassword: false,
    cognitoUser: {},
    sessionUserAttributes: {},
    hasSubmit: false,
    errors: "",
  };

  componentDidUpdate() {
    if (this.props.auth.isSignedIn) {
      history.push("/welcome");
    }
  }

  onInputChange = (e) => {
    const target = e.target;
    const value = target.value;
    const name = target.name;

    this.setState({ [name]: value });
  };

  renderLogin() {
    return (
      <div style={divStyle}>
        <div>
          <img src={IconImg} alt="VC Logo" style={imageStyle}></img>
        </div>
        <div style={linkStyle}>
         {/* Training information will be available soon. */}
         <a href="https://aimorange.precinctcentral.com/TED/ElectionForcePortal/Launchpad.aspx">Click here to access your training information and Vote Center assignment.</a>
		
        </div>
      </div>
      
      // <Form onSubmit={this.onSubmit}>
      //   <Form.Group>
      //     <Form.Label>Username or Email:</Form.Label>
      //     <Form.Control
      //       type="text"
      //       name="username"
      //       placeholder="Enter your username or email"
      //       value={this.state.username}
      //       onChange={this.onInputChange}
      //       autoFocus
      //       ref={this.usernameInput}
      //     ></Form.Control>
      //   </Form.Group>
      //   <Form.Group>
      //     <Form.Label>Password:</Form.Label>
      //     <Form.Control
      //       type="password"
      //       name="password"
      //       placeholder="Password"
      //       value={this.state.password}
      //       onChange={this.onInputChange}
      //     ></Form.Control>
      //     <br />
      //     <Link to="/reset" alt="Reset your password">
      //       <div className="alert alert-info">
      //         First time logging in or forgot your password?
      //       </div>
      //     </Link>
      //     {this.state.errors && (
      //       <span className="alert alert-danger d-block mx-auto mt-3">
      //         {this.state.errors}
      //       </span>
      //     )}
      //   </Form.Group>
      //   <br />
      //   {!this.state.hasSubmit ? (
      //     <Button type="submit" className="d-block mx-auto">
      //       Submit
      //     </Button>
      //   ) : (
      //     <Button className="d-block mx-auto" disabled>
      //       Loading...
      //     </Button>
      //   )}
      // </Form>
      );
    }

  renderChangePassword = () => {
    return (
      <Form onSubmit={this.handleNewPassword}>
        <Form.Group>
          <Form.Label>New Password:</Form.Label>
          <Form.Control
            type="password"
            name="password"
            placeholder="Password"
            value={this.state.password}
            onChange={this.onInputChange}
            autoFocus
          ></Form.Control>
          <br />
          <Form.Label>Your Full Name:</Form.Label>
          <Form.Control
            type="name"
            name="name"
            placeholder="Name"
            value={this.state.name}
            onChange={this.onInputChange}
          ></Form.Control>
        </Form.Group>
        <br />
        {!this.state.hasSubmit ? (
          <Button type="submit">Submit</Button>
        ) : (
          <Button disabled>Loading...</Button>
        )}
      </Form>
    );
  };

  renderForm() {
    if (this.state.changePassword) {
      return this.renderChangePassword();
    } else {
      return this.renderLogin();
    }
  }

  onSubmit = (e) => {
    e.preventDefault();
    this.setState({ hasSubmit: true });
    const user = new CognitoUser({
      Username: this.state.username,
      Pool: UserPool,
    });

    const authDetails = new AuthenticationDetails({
      Username: this.state.username,
      Password: this.state.password,
    });

    user.authenticateUser(authDetails, {
      onSuccess: (data) => {
        user.getSession((err, session) => {
          if (err) {
            console.error(err);
            history.push("/");
          }
          this.props.signIn(user, session);
        });
      },

      onFailure: (err) => {
        this.setState({
          errors: err.message,
          username: "",
          password: "",
          hasSubmit: false,
        });
        this.usernameInput.current.focus();
      },

      newPasswordRequired: (userAttributes, requiredAttributes) => {
        delete userAttributes.email_verified;
        this.setState({
          changePassword: true,
          cognitoUser: user,
          sessionUserAttributes: userAttributes,
          password: "",
          hasSubmit: false,
        });
      },
    });
  };

  handleNewPassword = (e) => {
    e.preventDefault();
    this.setState({ hasSubmit: true });
    const userAtts = {
      ...this.state.sessionUserAttributes,
      name: this.state.name,
    };
    this.state.cognitoUser.completeNewPasswordChallenge(
      this.state.password,
      userAtts,
      {
        onSuccess: (result) => {
          this.props.signIn(this.state.cognitoUser, result);
        },
        onFailure: (err) => {
          
		  console.log(err);

			alert(err.message + ". ");
			
		this.setState({
          errors: err.message,
          username: "",
          password: "",
          hasSubmit: false,
        });
       // this.usernameInput.current.focus();
 

          
        },
      }
    );
  };

  render() {
    return <div>{this.renderForm()}</div>;
  }
}

const imageStyle = {
  width: '50%',
  height: 'auto',
  border: 'none',
  padding: 12,
  margin: 8
}

const divStyle = {
  textAlign: 'center',
  fontSize: 24
}

const linkStyle = {
  padding: 10
}

const mapStateToProps = (state) => {
  return { auth: state.auth };
};

export default connect(mapStateToProps, { signIn })(Login);
